import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "page-body",
  style: {"margin":"53px 2% auto"}
}

import { defineAsyncComponent, ref, onMounted, watch } from "vue";
import { useMenuStore } from "@/store/menu";
import { uselayoutStore } from "@/store/layout";
import { storeToRefs } from "pinia";

export default /*@__PURE__*/_defineComponent({
  __name: 'BodyView',
  setup(__props) {

const Header = defineAsyncComponent(
  () => import("@/components/theme/elder/Header.vue")
);

let sidebar_toggle_var = ref<boolean>(false);
let display = ref<boolean>(false);
let layoutobj = ref<any>({});
const store = useMenuStore();
const storeLayout = uselayoutStore();
const { layouts: layouts } = storeToRefs(storeLayout);
watch(
  () => layouts,
  () => {
    layoutobj.value = storeLayout.layouts.settings.sidebar_setting;
  },
  { deep: true }
);
watch(
  () => "router",
  () => {
    if (
      window.innerWidth < 991 &&
      storeLayout.layouts.settings.layout === "Horizontal"
    ) {
      const newlayout = JSON.parse(
        JSON.stringify(layoutobj).replace(
          "horizontal-wrapper",
          "compact-sidebar compact-small material-icon"
        )
      );
      layoutobj.value = JSON.parse(JSON.stringify(newlayout))[
        storeLayout.layouts.settings.layout
      ];
    } else {
      layoutobj.value = JSON.parse(JSON.stringify(layoutobj))[
        storeLayout.layouts.settings.layout
      ];
    }
  }
);
function sidebar_toggle(value: boolean) {
  sidebar_toggle_var.value = !value;
}
function handleScroll() {
  if (window.innerWidth <= 1199) {
    display.value = true;
    store.togglesidebar = false;
  } else {
    store.togglesidebar = true;
    display.value = false;
  }
}
onMounted(() => {
  window.addEventListener("resize", handleScroll);
  layoutobj.value = storeLayout.layouts.settings.sidebar_setting;
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["page-wrapper", _unref(display) ? 'compact-wrapper ' : _unref(layoutobj)]),
    id: "pageWrapper"
  }, [
    _createVNode(_unref(Header)),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view)
    ])
  ], 2))
}
}

})